import { Cart } from 'types/cartServiceV2';
import { ProductLine, ProductType } from 'types/enrollmentService';

export function convertNewSaleCartIntoProductLine(cart: Cart): ProductLine[] {
  const pLines: ProductLine[] = [];
  const pLinesInCart = [...new Set(cart.cartItems.map((item) => item.productLineId))];
  pLinesInCart.forEach((lineId) =>
    pLines.push({
      id: lineId,
      productType: ProductType.NEW_SALE,
      confirmedPortfolioId: null,
      browsingCriteria: cart.lastUpdateBrowsingCriteria,
    }),
  );
  return pLines;
}
